import { API_HOST, Public_HOST } from "@/utils/request.js";
import { queryEvaluationTargetScoreDetail } from "@/api/index";
export default {
  // components: { Head },
  data() {
    return {
      query: this.$route.query,
      classLists: [],
      fileList: [],
      isloading: false,
      evaluateForm: {
        attachment: [],
        remark: "",
        targetCodes: "",
        userNames: this.$route.query.stuUserName
      },
      // 评价详情表单
      textarea: ""
    };
  },
  created() {
    console.log(this.$route.query, "this.$route.query");
    queryEvaluationTargetScoreDetail({
      userNames: this.$route.query.stuUserName,
      schoolNum: this.$route.query.schoolNum,
      schoolYear: this.$route.query.schoolYear,
      schoolTerm: this.$route.query.schoolTerm
    }).then(res => {
      this.evaluateForm.remark = res.data.remark;
      this.classLists = res.data.evaluationTargetListInfoVoList.map(i => {
        i.isShow = 0;
        i.evaluationTargetListInfoVoList.map(k => {
          k.isShow = 0;
          k.evaluationTargetListInfoVoList.map(j => {
            j.remark = JSON.parse(j.remark);
            return j;
          });
          return k;
        });
        return i;
      });
      if (!!res.data.attachment) {
        let str = res.data.attachment.split(",");
        str.forEach(img => {
          this.fileList.push({
            url: API_HOST() + "/storage" + img,
            raw: {
              fileUrl: img
            }
          });
          console.log(this.fileList, "fileList");
          this.evaluateForm.attachment.push(img);
        });
      }
    });
  },
  mounted() {},
  methods: {
    showHeader(val) {
      val.isShow = !val.isShow;
    },
    upIsLoading(flag) {
      this.isloading = flag;
    },
    onRemove(fileList) {
      const url = [];
      fileList.forEach(item => {
        url.push(item.raw.fileUrl);
      });
      this.evaluateForm.attachment = url;
    },
    httpRequest(res) {
      this.evaluateForm.attachment.push(res.data[0].filePath);
    },
    subFn() {
      this.isloading = true;
      // 评价指标代码处理
      let targetCodes = [];
      this.classLists.forEach(item => {
        item.evaluationTargetListInfoVoList.forEach(a => {
          a.evaluationTargetListInfoVoList.forEach(j => {
            if (j.evaluationResult === "0") {
              targetCodes.push(j.targetCode);
            }
          });
        });
      });
      this.evaluateForm.targetCodes = targetCodes.join(",");
      // 附件处理
      this.evaluateForm.attachment = this.evaluateForm.attachment.length === 0 ? "" : this.evaluateForm.attachment.join(",");
      // 提交处理
      addEvaluationTargetScore(this.evaluateForm).then(res => {
        if (res.code == "success") {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.$router.go(-1);
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
      this.isloading = false;
    }
  },
  beforeRouteEnter(to, from, next) {
    next();
  }
};